import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';

@Pipe({
  name: 'translateWithDate',
  pure: false,
  standalone: true,
})
export class TranslateWithDatePipe implements PipeTransform {
  constructor(private framework: PuzzleFrameworkService, private translate: TranslateService) {}

  transform(key: any): any {
    let string = this.translate.instant(key);
    // If necessary, replace the date
    if (string.indexOf('$date{') !== -1) {
      const pathDate = this.framework.getCurrentDate();
      string = this.framework.replaceDateTag(string, pathDate);
    }
    return string;
  }
}
